<template>
  <v-sheet class="d-flex" id="files-data-sheet">
    <v-card>
      <v-card-title>
        <h4>Annexes</h4>
      </v-card-title>
      <v-divider></v-divider>
      <v-list-tile
        v-for="file in $store.state.moduleApplications.currentApplication.application_data.files"
        :key="file.file_id"
      >
        <v-list-tile-avatar>
          <img
            :src="getPicture(file.file_name)"
            height="75px"
            @click="getFile(file.file_id, file.file_name)"
            style="cursor: pointer;"
            alt="user_pic"
          />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            <a @click="getFile(file.file_id, file.file_name)">
              <u>{{ file.file_name }}</u>
            </a>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon ripple @click="getFile(file.file_id, file.file_name)">
            <v-icon color="grey">cloud_download</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
      <v-btn color="primary" @click="getAllFiles">Tout télécharger</v-btn>
    </v-card>
  </v-sheet>
</template>

<script>
import logoJpg from '../../../assets/logo_jpg.png'
import logoPdf from '../../../assets/logo_pdf.png'
import logoPng from '../../../assets/logo_png.png'

export default {
  name: 'files-data-sheet',
  methods: {
    getFile (id, name) {
      this.$store.dispatch('moduleApplications/getFile', { id: id, name: name })
    },
    getAllFiles () {
      this.$store.dispatch('moduleApplications/getAllFiles', { id: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id })
    },
    getPicture (filename) {
      let ext = filename.split('.')[1]
      switch (ext) {
        case 'jpg':
          return logoJpg
        case 'pdf':
          return logoPdf
        case 'jpeg':
          return logoJpg
        case 'png':
          return logoPng
        default:
          break
      }
    }
  }
}
</script>
